<div class="select-area">
  <div class="input-area">

    <ng-container>
      <ng-container *ngIf="!inputArea">
        <dx-text-box
          #inputAreaFocus
          class="code-area"
          [readOnly]="true"
          [placeholder]="inputAreaPlaceholder"
        >
          <dx-validator *ngIf="!validationV2">
            <dxi-validation-rule
              *ngFor="let rule of validationRul"
              [type]="rule?.type"
              [message]="rule?.message"
            ></dxi-validation-rule>
          </dx-validator>

          <dx-validator *ngIf="validationV2">
            <dxi-validation-rule
              *ngFor="let rule of validationRules"
              [type]="rule?.type"
              [message]="rule?.message"
              [min]="rule?.min"
              [max]="rule?.max"
            >
            </dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </ng-container>
      <ng-container *ngIf="inputArea">
        <dx-text-box
          #inputAreaFocus
          class="code-area"
          placeholder="Kod"
          [readOnly]="isReadOnly"
          [label]="labelMode === 'outside' ? '' : labelText"
          [labelMode]="labelModeNew"
          (onValueChanged)="inputChange($event)"
          (onEnterKey)="inputChange($event, 'enter')"
          (dblclick)="searchBtnClick($event)"
          (onKeyDown)="handleKeyDown($event)"
          [(value)]="code"
          [width]="codeAreaWidth"
          [attr.title]="code || ''"
          [tabIndex]="tabIndex"

        >
          <dx-validator *ngIf="!validationV2">
            <dxi-validation-rule
              *ngFor="let rule of validationRul"
              [type]="rule?.type"
              [message]="rule?.message"
            ></dxi-validation-rule>
          </dx-validator>

          <dx-validator *ngIf="validationV2">
            <dxi-validation-rule
              *ngFor="let rule of validationRules"
              [type]="rule?.type"
              [message]="rule?.message"
              [min]="rule?.min"
              [max]="rule?.max"
            >
            </dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </ng-container>
      <dx-text-box [ngClass]="{'btn-container-disabled': isReadOnly}"
                   #titleAreaFocus
                   class="txt-read-only tab-ignore"
                   [value]="title"
                   [width]="aciklamawidth"
                   [readOnly]="true"
                   [tabindex]="-1"

      >
      <dxi-button
        *ngIf="showWarningIcon"
        location="after"
        name="warningIcon"
        class="tab-ignore"
        [options]="warningIconOptions"
        [tabindex]="-1"
      ></dxi-button>
        <dxi-button
        *ngIf="!isReadOnly"
          name="searchBtn"
          location="after"
          class="tab-ignore"
          [options]="searchBtnOptions"
          [tabindex]="-1"
        >
        </dxi-button>
        <dxi-button
        *ngIf="!isReadOnly"
          name="clearBtn"
          location="after"
          class="tab-ignore"
          [options]="clearBtnOptions"
          [tabindex]="-1"
        >
        </dxi-button>
        <dxi-button
          *ngIf="isShowInfo && !isReadOnly"
          location="after"
          name="infoBtn"
          class="tab-ignore"
          [options]="showInfoBtnOptions"
          [tabindex]="-1"
        >
        </dxi-button>
        <dxi-button
          *ngIf="isShowMap"
          location="after"
          name="showMapBtn"
          class="tab-ignore always-enabled"
          [options]="showMapBtnOptions"
          [tabindex]="-1"
        >
        </dxi-button>
        <dxi-button
          *ngIf="isShowViewBtn && !isReadOnly"
          location="after"
          name="viewBtn"
          class="tab-ignore"
          [options]="viewButtonOption"
          [tabindex]="-1"
        ></dxi-button>
      </dx-text-box>
    </ng-container>
  </div>
</div>
